/**
 * @Author:      jiang.weiwei
 * @DateTime:    2017-12-12 17:19:48
 * @Description: 新建用户
 */
"use strict";
angular.module("createUserModule", []).
controller("createUserCtrl", ["$scope", "$element", "$validation", "modalDialog", "$modalInstance", "httpService", "userId", "isCreate", "$q","checkPhoneAndEmail", function($scope, $element, $validation, modalDialog, $modalInstance, httpService, userId, isCreate, $q,checkPhoneAndEmail) {
	initStatus();
	initData();

	function initStatus() {
		$scope.status = {
			isCreate: isCreate,
			userId: userId,
			tname: '',//存储绅士姓名的值
			oldPhone: '',//存储手机号的值，用于校验是否重复
			oldEmail: '',//存储邮箱的值，用于校验是否重复
			m:false,//控制页面上手机号码重复提示的显示或隐藏
			e:false,//控制页面上邮箱号码重复提示的显示或隐藏
			mb:false,//控制页面上手机号input框变红的样式
			eb:false,//控制页面上邮箱input框变红的样式
			t:true,//存储校验是否通过的值
		};
		$scope.data={
			password:'',
			confirmPassword:''
		}
		$scope.userInfo = {
			id: userId,
			sex: 0
		};
	}

	function initData() {
		requestData();
		loadEncryptionLib().then(function() {
			encryptionMethods();
		});
	}
	$scope.cancel = function() {
		$modalInstance.dismiss();
	};

	/**
	 * [encryptionMethods description] 加密方法
	 * @return {[type]} [description]
	 */
	function encryptionMethods() {
		$.ajax({
			url: "/mcnadmin/web/user/publicKey.do",
			dataType: "text",
			success: function(data) {
				$("#encryption").remove();
				$("body").append("<script id='encryption'>" + data + "</script>");
			}
		});
	}
	/**
	 * [loadEncryptionLib description] 加载加密依赖文件
	 * @return {[type]} [description]
	 */
	function loadEncryptionLib() {
		var deffer = $q.defer();
		LazyLoad.js(["static/rsa/RSA.js", "static/rsa/BigInt.js", "static/rsa/Barrett.js"], function() {
			deffer.resolve();
		});
		return deffer.promise;
	}
	$scope.confirm = function() {
		$validation.validate($scope.createForm).success(function() {
			if($scope.data.password != $scope.data.confirmPassword){
				modalDialog.alertType('','两次密码输入不一致','info');
				return;
			}
			if($scope.status.t){
				if($scope.status.isCreate){
					$scope.userInfo.password = encryptedString(bodyRSA(), $scope.data.password);
					$scope.userInfo.confirmPassword = encryptedString(bodyRSA(), $scope.data.confirmPassword);
				}
				$scope.userInfo.trueName = $scope.status.tname;
				$modalInstance.close($scope.userInfo);
			}
		}).error(function() {
			angular.invalidPosition($scope.createForm, $element);
		});
	};

	function requestData() {
		if(!$scope.status.isCreate) {
			var params = {
				userId: userId
			};
			$scope.loadingPromise = httpService.http("/mcnadmin/admin/ugcuser/findById.do", params, "post").then(function(data) {
				var info = data.data;
				$scope.userInfo = {
					id: $scope.status.userId,
					userName: info.userName,
					trueName: info.truename,
					sex: info.sex,
					mobile: info.mobile,
					email: info.email,
					unit: info.unit,
					address: info.address
				};
				$scope.status.tname = info.truename;
				$scope.status.oldPhone = info.mobile;
				$scope.status.oldEmail = info.email;
			});
		}
	}
	/**
	 * [checkMobile description] 检查手机号是否存在
	 * @params {[obj]}[description]参数
	 * @return {[type]} [description]
	 */
	$scope.checkMobile= function(obj){
		obj.oldValue = $scope.status.oldPhone;
		checkPhoneAndEmail.checkPhone(obj).then(function(data){
			if(data){
				$scope.status.t = true;
				$scope.status.m = false;
				$scope.status.mb = false;
			}else{
				$scope.status.t = false;
				$scope.status.m = true;
				$scope.status.mb = true;
			}
		});
	};
	/**
	 * [checkMobile description] 检查邮箱是否存在
	 * @params {[obj]}[description]参数
	 * @return {[type]} [description]
	 */
	$scope.checkEmail = function(obj){
		obj.oldValue = $scope.status.oldEmail;
		checkPhoneAndEmail.checkEmail(obj).then(function(data){
			if(data){
				$scope.status.t = true;
				$scope.status.e = false;
				$scope.status.eb=false;
			}else{
				$scope.status.t = false;
				$scope.status.e = true;
				$scope.status.eb=true;
			}
		});
	};
}]);